import React, { FC } from 'react'
import StarIcon from '../../../public/static/icons/quiz-star.svg'
import css from './CardQuiz.module.scss'
import cn from 'classnames'

const CardQuiz: FC<{
  openHandler: React.Dispatch<React.SetStateAction<boolean>>
  className?: string
  isSmall?: boolean
}> = ({ openHandler, className, isSmall }) => {
  return (
    <li
      className={cn(
        css.container,
        isSmall && css['container--small'],
        className,
      )}
      title="Подобрать оттенок"
    >
      <div className={css.content}>
        <div className={cn(css.star, isSmall && css['star--small'])}>
          <StarIcon />
        </div>
        <h5 className={cn(css.note, isSmall && css['note--small'])}>
          пройти тест
          <span className={css.title}>подобрать оттенок основы в 3 шага</span>
        </h5>
      </div>
      <button
        type="button"
        className={cn(css.footer, isSmall && css['footer--small'])}
        onClick={() => openHandler(true)}
      >
        начать
      </button>
    </li>
  )
}

export default CardQuiz
